import { render, staticRenderFns } from "./kline.vue?vue&type=template&id=f5a36e1e&scoped=true"
import script from "./kline.vue?vue&type=script&lang=js"
export * from "./kline.vue?vue&type=script&lang=js"
import style0 from "./kline.vue?vue&type=style&index=0&id=f5a36e1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a36e1e",
  null
  
)

export default component.exports